import LocationSolidSVG from "@design-system/ui-icons/vanilla/LocationSolid"
import { createIcon } from "../createIcon"

export const LocationSolidIcon = createIcon(LocationSolidSVG)
